import axiosInstance from '../../../config/axiosConfig';
import { urlVulnerabilidadActivo } from '../../../config/apiURL';
import { extractArray, extractDataObject } from '../../utils/responseHelpers';

//Crear una vulnerabilidad para un activo
export async function createVulnerabilidadActivo(data) {
  try {
    const payload = {
      ...data,
      vac_costo:
        data?.vac_costo === "" || data?.vac_costo === null || data?.vac_costo === undefined
          ? null
          : Number(data.vac_costo),
      vac_fecha_inicio: data?.vac_fecha_inicio || null,
      vac_fecha_inactividad: data?.vac_fecha_inactividad || null,
    };

    const response = await axiosInstance.post(urlVulnerabilidadActivo, payload);
    return extractDataObject(response);
  } catch (error) {
    console.error('Error creating vulnerabilidad activo:', error);
    throw error;
  }
}

export async function getActivosVulnerabilidades() {
  try {
    const response = await axiosInstance.get(urlVulnerabilidadActivo);
    return extractArray(response);
  } catch (error) {
    console.error('Error fetching activos vulnerabilidades:', error);
    throw error;
  }
}

export async function getActivoVulnerabilidadPorId(id) {
  try {
    const response = await axiosInstance.get(`${urlVulnerabilidadActivo}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error fetching activo vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export async function updateActivoVulnerabilidad(id, data) {
  try {
    const payload = {
      ...data,
      vac_costo:
        data?.vac_costo === "" || data?.vac_costo === null || data?.vac_costo === undefined
          ? null
          : Number(data.vac_costo),
      vac_fecha_inicio: data?.vac_fecha_inicio || null,
      vac_fecha_inactividad: data?.vac_fecha_inactividad || null,
    };

    const response = await axiosInstance.put(`${urlVulnerabilidadActivo}/${id}`, payload);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error updating activo vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export async function deleteActivoVulnerabilidad(id) {
  try {
    const response = await axiosInstance.delete(`${urlVulnerabilidadActivo}/${id}`);
    return extractDataObject(response);
  } catch (error) {
    console.error(`Error deleting activo vulnerabilidad ${id}:`, error);
    throw error;
  }
}

export const getActivosByFechaInicio = async (fechaInicio, fechaFin, codigoEmpresa) => {
  try {
    const res = await axiosInstance.post(`${urlVulnerabilidadActivo}/filtrar-fecha`, {
      fechaInicio,
      fechaFin,
      codigoEmpresa
    });
    return extractArray(res);
  } catch (error) {
    console.error('Error fetching activos by fecha:', error);
    throw error;
  }
};